'use strict';

/**
 * Expose all strings in the booster for translation
 */

var _ = require('lodash');

function MapStrings (gettextCatalog) {

  this.Strings = {};

  this.init = function () {
    this.refreshStrings();
  };

  /**
   * NOTE: This needs to be run everytime the language changes
   */
  this.refreshStrings = function () {
    this._refreshCustomDrawStrings();
    this._refreshLeafletDrawStrings();
  };

  // ## Custom Draw Strings
  this._refreshCustomDrawStrings = function () {
    this.Strings.draw = {};
    this.Strings.draw.errors = {
      collision: gettextCatalog.getString('Error: Features cannot overlap or intersect')
    }
  };

  /**
   * Sets the strings that come bundled with leaflet
   * NOTE: Only strings that are actually used are listed here. For the full set of
   * possible strings see https://github.com/Leaflet/Leaflet.draw#customizing-language-and-text-in-leafletdraw
   */
  this._refreshLeafletDrawStrings = function () {
    L.drawLocal = {
      draw: {
        handlers: {
          circle: {
            tooltip: {
              start: gettextCatalog.getString('Click and drag to draw circle')
            },
            radius: gettextCatalog.getString('Radius')
          },
          marker: {
            tooltip: {
              start: gettextCatalog.getString('Click map to place marker')
            }
          },
          polygon: {
            tooltip: {
              start: gettextCatalog.getString('Click to start drawing shape'),
              cont: gettextCatalog.getString('Click to continue drawing shape'),
              end: gettextCatalog.getString('Click first point to close this shape')
            }
          },
          polyline: {
            error: gettextCatalog.getString('Error: shape edges cannot cross!'),
            tooltip: {
              start: gettextCatalog.getString('Click to start drawing line'),
              cont: gettextCatalog.getString('Click to continue drawing line'),
              end: gettextCatalog.getString('Click last point to finish line')
            }
          },
          rectangle: {
            tooltip: {
              start: gettextCatalog.getString('Click and drag to draw rectangle')
            }
          },
          simpleshape: {
            tooltip: {
              end: gettextCatalog.getString('Release mouse to finish drawing')
            }
          },
          text: {
            tooltip: {
              start: gettextCatalog.getString('Click map to place text')
            }
          }
        }
      },
      edit: {
        handlers: {
          edit: {
            tooltip: {
              text: gettextCatalog.getString('Drag handles, or marker to edit feature'),
              subtext: gettextCatalog.getString('Click cancel to undo changes')
            }
          },
          remove: {
            tooltip: {
              text: gettextCatalog.getString('Click on a feature to remove')
            }
          }
        }
      }
    };
  };
}

MapStrings.$inject = ['gettextCatalog'];
module.exports = MapStrings;


// WEBPACK FOOTER //
// ./~/@skycatch/skydash-saturn/boosters/map/src/app/MapStrings.js